import React, { useState } from 'react';
import './Experience.css';

import chingu   from '../../assets/images/Chingu.png';
import teko     from '../../assets/images/teko.png';
import mistakes from '../../assets/images/mistakes.png';
import webflow  from '../../assets/images/webflow.webp';
import left     from '../../assets/icons/left.png';
import right    from '../../assets/icons/right.png';

const experiences = [
  {
    image: webflow,
    jobTitle: 'Web Integrator (Webflow) at Resume-Examples',
    content: "Contributed to migrating company blogs from WordPress to Webflow, handling multilingual integration, SEO optimization, and issue resolution. Wrote custom scripts in Webflow's custom code section to enhance functionality and performance.",
    background: '#1a2a4a',
    bannerColor: '#3b82f6',
  },
  {
    image: chingu,
    jobTitle: 'React Developer Intern & Team Lead at Chingu',
    content: 'Led a remote team while building the frontend with React, supported backend tasks using Node.js and MongoDB, and managed sprints and backlogs in JIRA.',
    background: '#0d2e28',
    bannerColor: '#059669',
  },
  {
    image: teko,
    jobTitle: 'Web Developer Intern at Teko',
    content: 'Integrated UI mockups and customer charts, customized existing PrestaShop plugins, and contributed to a web application built with Symfony.',
    background: '#2e1a0d',
    bannerColor: '#d66022',
  },
  {
    image: mistakes,
    jobTitle: 'Learning Through Practice & Mistakes',
    content: 'Hands-on coding practice and learning from mistakes have significantly strengthened my debugging skills.',
    background: '#0d1a2e',
    bannerColor: '#173b88',
  },
];

export default function Experience() {
  const [index, setIndex] = useState(0);

  const prev = () => setIndex(i => (i - 1 + experiences.length) % experiences.length);
  const next = () => setIndex(i => (i + 1) % experiences.length);

  const { image, jobTitle, content, background, bannerColor } = experiences[index];

  return (
    <section className="experience-section" style={{ backgroundColor: background }}>
      <div className="grain" aria-hidden="true" />

      <div className="experience-header">
        <div className="section-label">Experience</div>
        <h2>Where I've Gained Experience</h2>
      </div>

      <div className="experience-layout">
        <div className="experience-card">

          <div className="experience-image">
            <img src={image} alt={jobTitle} />
            <span className="experience-counter">
              {String(index + 1).padStart(2, '0')} / {String(experiences.length).padStart(2, '0')}
            </span>
          </div>

          <div className="experience-content" style={{ backgroundColor: bannerColor }}>
            <h2>{jobTitle}</h2>
            <p>{content}</p>
          </div>

          <button className="nav-btn left"  onClick={prev} aria-label="Previous experience">
            <img src={left}  alt="" />
          </button>
          <button className="nav-btn right" onClick={next} aria-label="Next experience">
            <img src={right} alt="" />
          </button>
        </div>

        <div className="experience-dots">
          {experiences.map((_, i) => (
            <button
              key={i}
              className={`dot${i === index ? ' active' : ''}`}
              onClick={() => setIndex(i)}
              aria-label={`Go to experience ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}